import React, { useEffect, useState } from 'react'
import EnhanceTable from '../../table/table'
import {
  Button,
  TextField,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import AdminModal from '../../modal/adminModal'
import Snackbar from '../../snackbar/snackbar'
import { getData, postData, currentDate } from '../../actions'
import csv from 'papaparse'
import GetAppIcon from '@material-ui/icons/GetApp'
import CircularProgress from '@material-ui/core/CircularProgress'
import Backdrop from '@material-ui/core/Backdrop'
import { makeStyles } from '@material-ui/core/styles'
import FileDownload from 'js-file-download'
import json2csv from 'json2csv'
const convertToCSV = json2csv.parse

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: '95%'
  }
}))
export default function AddMany(props) {
  const classes = useStyles()
  const [users, setUsers] = useState([])
  const [myAccount, setMyAccount] = useState({})
  const [csvFile, setCsvFile] = useState('')
  const [departmentList, setDepartmentList] = useState([])
  const [emailField, setEmailField] = useState('')
  const [firstNameField, setFirstNameField] = useState('')
  const [lastNameField, setLastNameField] = useState('')
  const [departmentField, setDepartmentField] = useState('')
  const [roleField, setRoleField] = useState('')
  const [open, setOpen] = useState(false)
  const [error, setError] = useState(false)
  const [errorList, setErrorList] = useState([])
  const [addSnackbar, setAddSnackBar] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isProject, setIsProject] = useState('No')
  const [snackbarMessage, setSnackBarMessage] = useState('')

  useEffect(() => {
    getDepartments()
    getMyAccount()
  }, [])

  const createData = (
    email,
    firstName,
    lastName,
    department,
    role,
    isProject
  ) => {
    const userList = [...users]
    userList.push({ email, firstName, lastName, department, role, isProject })
    setUsers(userList)
  }

  const getMyAccount = async () => {
    const { data } = await getData('/userInfo')
    setMyAccount(data)
  }

  const getDepartments = async () => {
    try {
      const { data } = await getData('/departments/spreadsheet/list')
      if (data.length > 0) {
        console.log('consoleDepartment', data)
        setDepartmentList(data)
      }
    } catch (e) {
      alert('Oops something went wrong')
    }
  }

  const addUser = e => {
    e.preventDefault()
    const roleListIndex = [
      'Requestor',
      'Comptroller',
      'COO',
      'Department Head',
      'Accounting Staff',
      'Accounting Manager'
    ]
    const emailIndex = users.findIndex(row => row.email === emailField)
    const departmentListIndex = departmentList.findIndex(
      row => row.centerName === departmentField
    )
    const existingDataIndex = props.existingData.findIndex(
      row => row.email === emailField
    )
    if (emailField === '') {
      alert('Email is required')
      return
    }
    if (emailIndex >= 0) {
      alert('Email is already on the list')
      setEmailField('')
      return
    }
    if (myAccount.email === emailField) {
      alert('Email is already on the database')
      setEmailField('')
      return
    }
    if (existingDataIndex >= 0) {
      alert('Email is already on the database')
      setEmailField('')
      return
    }
    if (firstNameField.trim() === '') {
      alert('Firstname is required')
      setFirstNameField('')
      return
    }
    if (lastNameField.trim() === '') {
      alert('Lastname is required')
      setLastNameField('')
      return
    }
    if (departmentListIndex < 0) {
      alert('Department is required')
      return
    }
    if (roleListIndex.indexOf(roleField) < 0) {
      alert('Role is required')
      return
    }
    createData(
      emailField.trim(),
      firstNameField.trim(),
      lastNameField.trim(),
      departmentField,
      roleField,
      isProject
    )
    setFirstNameField('')
    setLastNameField('')
    setEmailField('')
    setDepartmentField('')
    setRoleField('')
    setIsProject('No')
    setAddSnackBar(true)
    setSnackBarMessage(`${emailField} added to the list`)
  }

  const deleteUser = data => {
    const newUsers = [...users]
    for (let email of data) {
      const selectedIndex = newUsers.findIndex(row => row.email === 'email')
      newUsers.splice(selectedIndex, 1)
    }
    setUsers(newUsers)
  }

  const saveData = async () => {
    if (users.length === 0) {
      alert('Please make sure to add data in the list first before saving')
      return
    }
    setIsLoading(true)
    const newUsers = []
    for (let user of users) {
      const departmentListIndex = departmentList.findIndex(
        row => row.centerName === user.department
      )
      newUsers.push({
        role: user.role,
        department: user.department,
        centerCode: departmentList[departmentListIndex].centerCode,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        isProject: user.isProject === 'Yes' ? user.isProject : null
      })
    }
    try {
      const { data } = await postData('/userInfo', { data: newUsers })
      if (data.insertedCount > 0) {
        // please note that this props saveData will call updated new users from the database and put it in the state hooks
        props.saveData()
        setUsers([])
        setIsLoading(false)
        props.handleClose()
      } else {
        alert('Please insert data in the table first')
        setIsLoading(false)
      }
    } catch (e) {
      console.log(e)
      setIsLoading(false)
      alert('Oops something went wrong')
    }
  }

  const manageCSV = files => {
    const fileTypes = ['csv']
    if (files.length > 0) {
      const fileType = files[0].name.split('.')
      if (!fileTypes.includes(fileType[fileType.length - 1])) {
        alert('CSV file only')
        return
      }
      csv.parse(files[0], {
        complete: results => {
          const columns = ['email', 'firstName', 'lastName', 'code', 'role']
          const userList = []
          const listOFErrors = []
          const csvResults = results.data
          csvLoop: for (const obj in results.data) {
            // this is the first column of the csv validated to match the names of the columns variable above
            if (obj === '0') {
              // this is to make sure that the csv columns will not exceed to its limit
              if (results.data[obj].length === 5) {
                for (let fields of results.data[obj]) {
                  if (columns.indexOf(fields) < 0) {
                    alert(
                      `Invalid column name '${fields}' at row 0 of csv file`
                    )
                    break csvLoop
                  }
                }
              } else {
                alert('The columns limit exceeded at row 0 of csv file')
                break csvLoop
              }
            } else {
              const csv = results.data[0]
              // this fields is initialize in variables
              const email = results.data[obj][csv.indexOf(columns[0])]
              const firstName = results.data[obj][csv.indexOf(columns[1])]
              const lastName = results.data[obj][csv.indexOf(columns[2])]
              const code = results.data[obj][csv.indexOf(columns[3])]
              const role = results.data[obj][csv.indexOf(columns[4])]
              const department = departmentList.filter(
                row => row.centerCode === code
              )[0]
              // initializate to check if the email is already on the database
              const existingDataIndex = props.existingData.findIndex(
                row => row.email === email
              )
              // make sure the email contains a value
              if (email && firstName && lastName && role) {
                //make sure the email is not duplicated
                if (userList.findIndex(row => row.email === email) < 0) {
                  // check if the email is already on the database
                  if (existingDataIndex < 0 && email !== myAccount.email) {
                    //make sure the department exist
                    if (department) {
                      userList.push({
                        email,
                        firstName,
                        lastName,
                        department: department.centerName,
                        role
                      })
                    } else {
                      listOFErrors.push({
                        email,
                        error: `The department code is not found in the database`
                      })
                    }
                  } else {
                    listOFErrors.push({
                      email,
                      error: `The email is already on the database`
                    })
                  }
                } else {
                  listOFErrors.push({
                    email,
                    error: `The email is duplicated and will not be added to the list`
                  })
                }
              } else {
                // the last data of array has a null value, check if the email has value
                if (email) {
                  listOFErrors.push({
                    email,
                    error: `Incomplete fields`
                  })
                }
              }
            }
          }
          if (listOFErrors.length > 0) {
            showError(listOFErrors)
          }
          setUsers(userList)
          setCsvFile('')
        }
      })
    }
  }

  const showError = listArray => {
    setErrorList(listArray)
    setError(true)
  }

  return (
    <>
      <Backdrop className={classes.backdrop} open={isLoading}>
        <CircularProgress color='inherit' />
      </Backdrop>
      <AdminModal
        title='List of Invalid data'
        open={error}
        handleClose={() => {
          setError(false)
          setErrorList([])
        }}
        actions='The data stated will not be added on the list'
      >
        <Grid container spacing={2}>
          {errorList.map(({ email, error }) => (
            <Grid item xs={12} sm={12}>
              <p>{`Email: ${email}`}</p>
              <p>{`Error: ${error}`}</p>
            </Grid>
          ))}
        </Grid>
      </AdminModal>
      <AdminModal
        title='User Details'
        open={open}
        handleClose={() => {
          setOpen(false)
        }}
      >
        <div style={{ width: '100%', maxWidth: '400px' }}>
          <form onSubmit={addUser}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextField
                  type='email'
                  variant='outlined'
                  label='Email'
                  size='small'
                  value={emailField}
                  onChange={e => {
                    setEmailField(e.target.value)
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant='outlined'
                  label='Firstname'
                  size='small'
                  value={firstNameField}
                  onChange={e => {
                    setFirstNameField(e.target.value)
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant='outlined'
                  label='Lastname'
                  size='small'
                  value={lastNameField}
                  onChange={e => {
                    setLastNameField(e.target.value)
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Autocomplete
                  id='department'
                  options={departmentList}
                  getOptionLabel={option => option.centerName}
                  fullWidth
                  inputValue={departmentField}
                  onInputChange={(e, inputValue) =>
                    setDepartmentField(inputValue)
                  }
                  size='small'
                  renderInput={params => (
                    <TextField
                      {...params}
                      label='Department'
                      variant='outlined'
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Autocomplete
                  id='role'
                  options={[
                    'Requestor',
                    'Comptroller',
                    'COO',
                    'Department Head',
                    'Accounting Staff',
                    'Accounting Manager'
                  ]}
                  getOptionLabel={option => option}
                  fullWidth
                  inputValue={roleField}
                  onInputChange={(e, inputValue) => setRoleField(inputValue)}
                  size='small'
                  renderInput={params => (
                    <TextField {...params} label='Role' variant='outlined' />
                  )}
                />
              </Grid>
              {roleField === 'Requestor' || roleField === 'Department Head' ? (
                <Grid item xs={12} sm={12}>
                  <FormControl className={classes.formControl}>
                    <InputLabel id='demo-simple-select-label'>
                      Is Project
                    </InputLabel>
                    <Select
                      labelId='demo-simple-select-label'
                      id='demo-simple-select'
                      value={isProject}
                      onChange={e => {
                        console.log(e.target.value)
                        setIsProject(e.target.value)
                      }}
                    >
                      <MenuItem value='Yes'>Yes</MenuItem>
                      <MenuItem value='No'>No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              ) : null}

              <Grid item xs={12} sm={12}>
                <Button
                  type='submit'
                  color='primary'
                  style={{ float: 'right' }}
                >
                  Add
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </AdminModal>
      <div style={{ zIndex: '1000' }}>
        <Snackbar
          open={addSnackbar}
          handleClose={() => {
            setAddSnackBar(false)
          }}
        >
          {snackbarMessage}
        </Snackbar>
      </div>

      <EnhanceTable
        delete={dataArray => deleteUser(dataArray)}
        tableName={
          <>
            <Button
              color='primary'
              onClick={() => {
                setOpen(true)
              }}
            >
              Add User
            </Button>

            <Button color='primary' component='label'>
              Import CSV
              <input
                type='file'
                style={{ display: 'none' }}
                value={csvFile}
                onChange={e => {
                  setCsvFile(e.target.value)
                  manageCSV(e.target.files)
                }}
              />
            </Button>
            <Button
              color='secondary'
              component='label'
              startIcon={<GetAppIcon />}
              onClick={() => {
                const csvFile =
                  users.length > 0
                    ? [...users]
                    : [
                      {
                        firstName: '',
                        lastName: '',
                        email: '',
                        code: '',
                        role: ''
                      }
                    ]
                FileDownload(
                  convertToCSV(csvFile),
                  `Users(${currentDate()}).csv`
                )
              }}
            >
              Download CSV
            </Button>
            {/* <Button
              style={
                users.length > 0
                  ? { visibility: 'visible', float: 'right' }
                  : { visibility: 'hidden' }
              }
              variant='contained'
              color='primary'
              onClick={() => {
                setOpen(true)
              }}
              startIcon={<GetAppIcon />}
            >
              Download as CSV
            </Button> */}
          </>
        }
        tHeader={[
          {
            id: 'email',
            numeric: false,
            disablePadding: true,
            label: 'Email'
          },
          {
            id: 'firstName',
            numeric: false,
            disablePadding: false,
            label: 'Firstname'
          },
          {
            id: 'lastName',
            numeric: false,
            disablePadding: false,
            label: 'Lastname'
          },
          {
            id: 'department',
            numeric: false,
            disablePadding: false,
            label: 'Department'
          },
          {
            id: 'role',
            numeric: false,
            disablePadding: false,
            label: 'Role'
          },
          {
            id: 'isProject',
            numeric: false,
            disablePadding: false,
            label: 'Is Project'
          }
        ]}
        defaultOrderBy='email'
        tData={users}
      />

      <div style={{ float: 'right' }}>
        <Button type='button' size='small' color='primary' onClick={saveData}>
          Save
        </Button>
        <Button
          type='button'
          size='small'
          color='secondary'
          onClick={() => {
            props.handleClose()
            setUsers([])
          }}
        >
          Discard
        </Button>
      </div>
    </>
  )
}
